

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SurgeryApi } from '../api/surgery.api';
import { switchMap, map } from 'rxjs/operators';
import { SurgeryData, Surgery } from '../../../interfaces/masters/surgery';

@Injectable()
export class SurgeryService extends SurgeryData {

  constructor(private api: SurgeryApi) {
    super();
  }
  list(url: string): Observable<Surgery[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Surgery>{
      return this.api.getById(url);
  }

  create(url: string, data:Surgery): Observable<Surgery> {
    return this.api.add(url,data);
  }

  update(url: string, data:Surgery): Observable<Surgery> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
